import { Dispatch } from "redux";
import { ApiConfig } from "../../../../../config/ApiConfig";
import { Document } from "../../../../../models/Document";
import { AppStateWithData } from "../../../../AppStateWithData";
import { constructSearchByIdsQueryRequest, SearchQueryRequest } from "./constructDocumentsQuery";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";

export const fetchHiddenDocumentsActionTypes = createRequestActionTypes('FETCH_HIDDEN_DOCUMENTS')

interface SearchByIdsResponse {
    data: { Value: { Source: Document } }[]
}

interface FetchDocumentAdditionalData {
    docIds: string[]
}

export const fetchHiddenDocuments = (config: ApiConfig) => (docIds: string[]) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<Document[], SearchQueryRequest, FetchDocumentAdditionalData> = {
        method: 'POST',
        requestActionTypes: fetchHiddenDocumentsActionTypes,
        actionAdditionalData: {
            docIds
        },
        url: `${config.API_URL}/search/SearchByIds`,
        body: constructSearchByIdsQueryRequest(docIds),
        processResultBeforeDispatch: (result: SearchByIdsResponse): Document[] => {
            return result.data.map(x => x.Value.Source)
        }
    }

    dispatch<any>(createRequestThunk(thunkParams))
}